<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sa0TsZ/tc-custom/9781429988070.jpg?1730581085906" alt="This image is the cover for the book Strange Piece of Paradise"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Strange Piece of Paradise
      </h1>
      <p class="bookDescription body article font2">
        <p>In the summer of 1977, Terri Jentz and her Yale roommate, Shayna Weiss, make a cross-country bike trip. They pitch a tent in the desert of central Oregon. As they are sleeping, a man in a pickup truck deliberately runs over the tent. He then attacks them with an ax. The horrific crime is reported in newspapers across the country<i>. </i>No one is ever arrested. Both women survive, but Shayna suffers from amnesia, while Terri is left alone with memories of the attack. Their friendship is shattered.<br/><br/>Fifteen years later, Terri returns to the small town where she was nearly murdered, on the first of many visits she will make "to solve the crime that would solve me." And she makes an extraordinary discovery: the violence of that night is as present for the community as it is for her. Slowly, her extensive interviews with the townspeople yield a terrifying revelation: many say they know who did it, and he is living freely in their midst. Terri then sets out to discover the truth about the crime and its aftermath, and to come to terms with the wounds that broke her life into a before and an after. Ultimately she finds herself face-to-face with the alleged axman.<br/><br/>Powerful, eloquent, and paced like the most riveting of thrillers, <i>Strange Piece of Paradise </i>is the electrifying account of Terri's investigation into the mystery of her near murder. A startling profile of a psychopath, a sweeping reflection on violence and the myth of American individualism, and a moving record of a brave inner journey from violence to hope, this searing, unforgettable work is certain to be one of the most talked about books of the year.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Terri Jentz
      </h2>
      
      <p class="authorDescription body article"><B>Terri Jentz </B>is a screenwriter and lives in Los Angeles. <I>Strange Piece of Paradise</I> is her first book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07e5a268